// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#header[data-v-8026e2bc] {\n  background-color: #272A33;\n  position: sticky;\n  top: 0;\n  z-index: 5;\n}\n#header_body[data-v-8026e2bc] {\n  height: 50px;\n}", ""]);
// Exports
module.exports = exports;
